<template>
  <div class="c-list__content">
    <h2 class="c-list__title">
      <a 
        v-bind:href="item.url" 
        class="c-list__link">{{item.title}}</a>
    </h2>
    <div class="c-list__body" v-html="item.body"></div>
    <dl class="c-list__meta" v-if="validDate">
      <dt class="c-list__meta-title">Publication Date</dt>
      <dd class="c-list__meta-detail"><time v-bind:datetime="item.publicationDate">{{item.publicationDate | formatDate}}</time></dd>
    </dl>
  </div>
</template>

<script>
import moment from "NodeModules/moment/moment";

export default {
  name: "SearchItemPage",
  props: {
    item: {
      type: Object
    }
  },
  computed: {
    validDate: function () {
      return moment(this.item.publicationDate).isAfter('1900-01-01', 'year');
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/components/geneco/results/SearchItemPage.vue